export default "__VITE_ASSET__4TgzQH6o__"